import { FirebaseApp, initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import { connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBOPgKXqa8qQJKEkrZwxhPh7mRB3HRFQ38",
  authDomain: "llm-bots.firebaseapp.com",
  projectId: "llm-bots",
  storageBucket: "llm-bots.appspot.com",
  messagingSenderId: "445480323020",
  appId: "1:445480323020:web:f4f25468711c341916ff69",
  measurementId: "G-WCS2WQY4D7"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);

// Firestoreへの接続をエミュレーターに変更する
export const functions = getFunctions(app, 'asia-northeast1');

if (location.hostname === '127.0.0.1' || location.hostname === 'localhost'|| location.hostname === '192.168.1.13') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099');
  console.log('local emulator auth', auth);
  connectFirestoreEmulator(db, '127.0.0.1', 8800);
  connectFunctionsEmulator(functions, "127.0.0.1", 5020);
}

// Cloud Functions関数の割当
import { httpsCallable } from "firebase/functions";

export const chatCompletion = httpsCallable(functions, 'chatCompletion');
export const chatCompletionStream = httpsCallable(functions, 'chatCompletionStream', { timeout: 540000 });
export const sendChatMessage = httpsCallable(functions, 'sendChatMessage');
export const word2Vec = httpsCallable(functions, 'word2Vec');
export const deleteChatSession = httpsCallable(functions, 'deleteChatSession');
export const apiTest = httpsCallable(functions, 'apiTest');
export const getModels = httpsCallable(functions, 'getModels');
